import { GetInterface, Codec, array, number, string } from "purify-ts/Codec"

export const VegobjektType = Codec.interface({
  id: number,
  navn: string,
})

export type VegobjektType = GetInterface<typeof VegobjektType>

export const VegobjektTypeList = array(VegobjektType)

export type VegobjektTypeList = GetInterface<typeof VegobjektTypeList>
